import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addsms-scheduler',
  templateUrl: './addsms-scheduler.component.html',
  styleUrls: ['./addsms-scheduler.component.css']
})
export class AddsmsSchedulerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
